<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="sliderValues"
                show-decimal
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';
import { tailwindThemePropSort } from '@/utils/tailwind-helper';

export default {
    name: 'zoom',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Image Zoom',
            sliderIndex: 9, // 9 = index of 1.0
            tailwindDefinitionProp: 'zoom',
        };
    },

    computed: {
        sliderValues() {
            const sliderValues = [...this.themeObjectKeys];

            sliderValues.sort(tailwindThemePropSort);

            return sliderValues;
        },
    },
};
</script>
